module.exports = __webpack_public_path__ + "static/media/scene_two.c7be8b8c.png";